/** @jsx jsx */
import { jsx, Flex, Box } from 'theme-ui';
import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

// Components
import Avatar from '../avatar';
import Text, { TEXT_TYPES } from '../text';

// Styles
import { baseStyle } from './style';

export interface AuthorDescriptionProps {
  className?: string;
  authorImage?: ImageType;
  authorName: string;
  authorPosition: string;
  authorCompany: string;
  authorDescription: string;
}

const AuthorDescription: FunctionComponent<AuthorDescriptionProps> = React.memo(
  ({
    className,
    authorImage,
    authorName,
    authorPosition,
    authorCompany,
    authorDescription,
  }) => (
    <Flex
      className={classNames('AuthorDescription', className)}
      sx={baseStyle.mainContainer}
    >
      <Avatar
        size={['225px', null, '200px', '280px']}
        image={authorImage}
        sx={baseStyle.avatar}
      />
      <Box sx={baseStyle.informationContainer}>
        <Text
          type={TEXT_TYPES.DISPLAY_SUBHEAD}
          sx={baseStyle.informationAuthorName}
        >
          {authorName}
        </Text>
        <Text type={TEXT_TYPES.BYLINE} sx={baseStyle.informationAuthorName}>
          {authorPosition}
        </Text>
        <Text type={TEXT_TYPES.BYLINE} sx={baseStyle.informationAuthorCompany}>
          {authorCompany}
        </Text>
        <Text
          type={TEXT_TYPES.BODY_1}
          sx={baseStyle.informationAuthorDescription}
        >
          <span dangerouslySetInnerHTML={{ __html: authorDescription }} />
        </Text>
      </Box>
    </Flex>
  ),
);

export default AuthorDescription;
